
export enum CategoriesWithRules {
  DayCare = '25',
  Boarding = '68',
  Training = '74',
  Grooming = '71',
  FullServiceGrooming = '72',
  Enrichment = '73',
  Bath = '70'
}

export const CategoriesWithMultiSelection = [
  CategoriesWithRules.Grooming,
  CategoriesWithRules.FullServiceGrooming,
];

export const CategoriesWithQuantity = [
  CategoriesWithRules.Training,
  CategoriesWithRules.Enrichment,
];

export enum ServiceTypes {
  Service = '3',
  Package = '2',
}
